import { gql } from '@apollo/client';

export const PROJECT_ENGINEERING_TAB = gql`
  query ProjectEngineeringTab($id: ID!) {
    baseProject(id: $id) {
      id
      health {
        id
        healthChecks {
          id
          name
          status
          targetZone
        }
      }
      engineeringPolicy {
        id
        projectId
        productionOwnership
        deliveryModel
        ppcLink
        ppcLinkUpdatedAt
        updatedAt
        createdAt
      }
      engineeringIncidents {
        id
        projectId
        shortDescription
        severity
        linkToDetails
        notes
        updatedAt
        createdAt
      }
      engineeringBugs {
        id
        projectId
        shortDescription
        isCritical
        linkToDetails
        notes
        updatedAt
        createdAt
      }
    }
  }
`;
